import React, { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [cartOpen, setCartOpen] = useState(false);

  // 🟢 Abrir/Cerrar carrito
  const openCart = () => setCartOpen(true);
  const closeCart = () => setCartOpen(false);

  // 🧮 Recalcular total general
  const recalcTotal = (items) => {
    const total = items.reduce((acc, item) => acc + item.total, 0);
    setTotalPrice(total);
  };

  // 🧾 Cargar carrito desde localStorage
  useEffect(() => {
    const saved = localStorage.getItem("adastra_cart");
    if (saved) {
      const parsed = JSON.parse(saved);
      setCart(parsed);
      recalcTotal(parsed);
    }
  }, []);

  // 💾 Guardar carrito en localStorage cuando cambie
  useEffect(() => {
    if (cart.length > 0) {
      localStorage.setItem("adastra_cart", JSON.stringify(cart));
    } else {
      localStorage.removeItem("adastra_cart");
    }
  }, [cart]);

  // ➕ Agregar producto
  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      let updated;

      if (existing) {
        const pricePerPack = product.total / product.quantity;

        updated = prev.map((item) =>
          item.id === product.id
            ? {
                ...item,
                quantity: item.quantity + product.quantity,
                total: (item.quantity + product.quantity) * pricePerPack,
              }
            : item
        );
      } else {
        updated = [...prev, product];
      }

      recalcTotal(updated);
      return updated;
    });
  };

  // 🔄 Actualizar cantidad
  const updateQuantity = (id, newQuantity) => {
    setCart((prev) => {
      const updated = prev.map((item) => {
        if (item.id === id) {
          const qty = Math.max(newQuantity, 1);

          // precio por pack basado en el total real de este item
          const pricePerPack = item.total / item.quantity;

          return {
            ...item,
            quantity: qty,
            total: pricePerPack * qty,
          };
        }
        return item;
      });

      recalcTotal(updated);
      return updated;
    });
  };

  // 🗑️ Eliminar producto
  const removeFromCart = (id) => {
    setCart((prev) => {
      const updated = prev.filter((item) => item.id !== id);
      recalcTotal(updated);
      return updated;
    });
  };

  // 🧹 Vaciar carrito
  const clearCart = () => {
    setCart([]);
    setTotalPrice(0);
    localStorage.removeItem("adastra_cart");
  };

  // 📦 Total de ítems reales (sumatoria de quantity)
  const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        updateQuantity,
        removeFromCart,
        clearCart,
        totalPrice,
        totalItems,
        cartOpen,
        openCart,
        closeCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
